<template>
  <section class="doc-processing-info detail-list">
    <div v-if="doc.status === 'failed'" class="columns">
      <div class="column is-one-fifth label">
        Processing error
      </div>
      <div class="column">
        <b-tag v-if="doc.task_error" type="is-warning">
          {{ doc.task_error }}
        </b-tag>
        <div v-else class="empty">
          <b-icon icon="google-downasaur" size="is-medium"></b-icon>
          No error message available. Check logs.
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Requeued
      </div>
      <div class="column">
        {{ doc.task_enqueued_count - 1 }} times
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-fifth label">
        Logs
      </div>
      <div class="column">
        <log-viewer :logs="doc.logs" :is-busy="doc.busyLoadingLogs" />
      </div>
    </div>
  </section>
</template>

<script>
  import LogViewer from './LogViewer'

  export default {
    name: "DocumentDetailsProcessing",
    components: { LogViewer },
    props: {
      doc: { type: Object, required: true }
    }
  }
</script>


<style>
  .processing-error .empty {
    opacity: 0.5;
  }
  .detail-list .label {
    text-align: right;
  }
</style>
